import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SketchOutlinedSvg from "@ant-design/icons-svg/es/asn/SketchOutlined";
import AntdIcon from "../components/AntdIcon";
var SketchOutlined = function SketchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SketchOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SketchOutlined.displayName = 'SketchOutlined';
}
export default /*#__PURE__*/React.forwardRef(SketchOutlined);